import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label, FormGroup } from 'reactstrap';

const EditLeagueScheduleModal = ({ isOpen, toggle, onSave, schedule }) => {
  const [editedSchedule, setEditedSchedule] = useState({
    league: null,
    title: '',
    sort_order: 99
  });

  useEffect(() => {
    if (schedule) {
      setEditedSchedule({
        league: schedule.league,
        title: schedule.title || '',
        sort_order: schedule.sort_order || 99
      });
    }
  }, [schedule]);

  const handleSave = () => {
    onSave(editedSchedule);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedSchedule(prev => ({ ...prev, [name]: value }));
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Edit Schedule</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="title">Schedule Title *</Label>
          <Input
            type="text"
            id="title"
            name="title"
            value={editedSchedule.title}
            onChange={handleChange}
            required
          />
        </FormGroup>
        <FormGroup>
          <Label for="sort_order">Sort Order</Label>
          <Input
            type="number"
            id="sort_order"
            name="sort_order"
            value={editedSchedule.sort_order}
            onChange={handleChange}
            placeholder="99"
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSave} disabled={!editedSchedule.title}>
          Save Changes
        </Button>{' '}
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditLeagueScheduleModal;
